import React from 'react';
import ConfirmModal from '../../../../FlowchartView/components/ConfirmModal';

/**
 * TodoModals - All modals used by TodoItem
 * - Delete confirmation modal
 */
const TodoModals = ({
  // Delete confirmation
  showDeleteConfirm,
  taskName,
  onConfirmDelete,
  onCancelDelete,
}) => {
  return (
    <>
      {/* Delete confirmation modal */}
      <ConfirmModal
        isOpen={showDeleteConfirm}
        title="Delete Mission"
        message={`Are you sure you want to delete "${taskName}"? This action cannot be undone.`}
        confirmLabel="Delete"
        cancelLabel="Cancel"
        confirmVariant="danger"
        icon="🗑️"
        onConfirm={onConfirmDelete}
        onCancel={onCancelDelete}
      />
    </>
  );
};

export default TodoModals;
